module.exports = __webpack_public_path__ + "assets/img/48a.5411d959.jpeg";